import { WaybillNoType } from "../enum/WaybillNoType";

export const WaybillNoTypeNameMap = {
    [WaybillNoType.EWAYBILL]: "电子面单号",
    [WaybillNoType.MANUAL]: "录入的单号",
    [WaybillNoType.DROP_SHIPPING]: "代发的单号",
    [WaybillNoType.UNPRINTED_EWAYBILL]: "仅获取未打印的单号",
};

export const WaybillNoTypeTipMap = {
    [WaybillNoType.EWAYBILL]: "即当前店铺获取的单号，包括打印和未打印的，不包括已回收和已删除的单号 ",
    [WaybillNoType.MANUAL]:
        "发货易软件内录入的单号，单号没录入物流公司则导出为空；录入的单号没有打印时间，无法按打印时间导出",
    [WaybillNoType.DROP_SHIPPING]: "经过发货易供货商版系统，供货商发货回传的快递单号",
    [WaybillNoType.UNPRINTED_EWAYBILL]: "发货易软件内获取的电子面单号且未打印",
};
